import vueMainInstance from "../../main";

const namespaced = true;

const state = {
  workflowData: {
    users: [],
    cost_centres: [],
    delegation_tasks: []
  }
};

const getters = {};

const mutations = {
  setWorkflowData(state, workflowData) {
    state.workflowData = workflowData;
  }
};

const actions = {
  loadWorkflowData({ commit }) {
    vueMainInstance.axios.get("settings/workflow/get-data").then(response => {
      commit("setWorkflowData", response.data);
    });
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
